import { Navigate, useParams } from "react-router-dom";
import { TenantBrandingSettings } from "@/components/tenant-branding-settings";
import { useAuthStore } from "@/stores/authStore";

export function TenantAdminBrandingPage() {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={`/t/${tenantSlug}/login`} replace />;
  }

  if (user?.role !== "tenant_admin") {
    return <Navigate to={`/t/${tenantSlug}/dashboard`} replace />;
  }

  return (
    <main className="mx-auto max-w-4xl px-4 py-10">
      <TenantBrandingSettings tenantSlug={tenantSlug} />
    </main>
  );
}
